import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {buildSearchParams} from './productSearchReducer';
import * as productSearchActions from './productSearchActions';
import DateSelectionTrayOption from './DateSelectionTrayOption';
import Modal from '../common/Modal';
import classNames from 'classnames';
import moment from 'moment';

class DateSelectionTray extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: !!this.props.selected_date
    };

    this.clearSelectedDate = this.clearSelectedDate.bind(this);
    this.openContinuousOption = this.openContinuousOption.bind(this);
    this.openPublishedFareOption = this.openPublishedFareOption.bind(this);
    this.openCharterOption = this.openCharterOption.bind(this);
    this.openCrowdsourceOption = this.openCrowdsourceOption.bind(this);
    this.openSharedCharterOption = this.openSharedCharterOption.bind(this);
    this.decrementDate = this.decrementDate.bind(this);
    this.incrementDate = this.incrementDate.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if(!this.props.selected_date && !!nextProps.selected_date) {
      setTimeout(() => {
        this.setState({ modalOpen: true });
      }, 0);
    } else if(!nextProps.selected_date) {
      setTimeout(() => {
        this.setState({ modalOpen: false });
      }, 0);
    }
  }

  clearSelectedDate(e) {
    this.setState({ modalOpen: false });

    // 500ms matches the css transition time
    // TODO get better react animation strategy
    setTimeout(() => {
      this.props.onDateChange(null);
    }, 500);
  }

  openContinuousOption(e) {
    e.stopPropagation();
    const {continuous} = this.props.trayOptions
    window.location.href = encodeURI(continuous.schedule_path);
  }

  openPublishedFareOption(e) {
    e.stopPropagation();
    this.props.actions.broadcastSelectedFlightType('published_fare');
    this.props.actions.goToResultsPage('schedule');
  }

  openCharterOption(e) {
    e.stopPropagation();

    this.props.actions.broadcastSelectedFlightType('charter');
    this.props.actions.openTimeSelection();
  }

  openSharedCharterOption(e) {
    e.stopPropagation();

    this.props.actions.broadcastSelectedFlightType('shared_charter');
    this.props.actions.openSharedCharterSearch();
  }

  routeToBookingInquiryForm() {
    var f = stations => {
      var station = stations[0];
      if (!station) return;
      return `${station.subtitle} (${station.title}) (${station.code})`;
    }

    var params = {
      departure_date: moment(this.props.selected_date).format('YYYY-MM-DD'),
      origin: f(this.props.origins),
      destination: f(this.props.destinations),
      back: '/flight_search'
    }

    window.location = '/anywhere_requests/no_results?' + $.param(params);
  }

  openCrowdsourceOption(e) {
    e.stopPropagation();
    this.props.actions.broadcastSelectedFlightType('crowdsource');
    this.props.actions.openCrowdsourceSearch();
  }

  renderHeading(){
    return (
      <div className="tray-heading">
        <div className='date-control decrement' onClick={this.decrementDate}>
          <i className="fa fa-angle-left fa-2x" />
        </div>
        <div className="text-center">
          <h3>{this.renderDate()}</h3>
          <div className="pax-count">{this.props.passengers} Adult{this.props.passengers >  1 ? 's' : ''}</div>
        </div>
        <div className='date-control increment' onClick={this.incrementDate}>
          <i className="fa fa-angle-right fa-2x" />
        </div>
      </div>
    );
  }

  renderDate(){
    return moment(this.props.selected_date).
      format('ddd, MMM D, YYYY').
      toUpperCase();
  }

  decrementDate(e){
    e.stopPropagation();

    this.props.onDateChange(
      moment(this.props.selected_date).subtract('1', 'day')
    );
  }

  incrementDate(e){
    e.stopPropagation();

    this.props.onDateChange(
      moment(this.props.selected_date).add('1', 'day')
    );
  }

  renderContinuous() {
    const {continuous} = this.props.trayOptions
    if(_.isEmpty(continuous)) {
      return
    }

    let details = `Flights depart continuously between ${continuous.origins.join(', ')} and ${continuous.destinations.join(', ')}`

    return (
      <DateSelectionTrayOption
        name="Blade Airport"
        details={details}
        price={continuous.pricing}
        perSeat={true}
        onClick={this.openContinuousOption}
        className={classNames({invisible: this.props.trayLoading})}
      />
    )
  }

  renderSharedCharter() {
    const {shared_charter} = this.props.trayOptions
    if(_.isEmpty(shared_charter)) {
      return
    }

    let details = 'Launch a flight at a lower upfront price. Includes 2 seats. Unused seats are offered to others'

    return (
      <DateSelectionTrayOption
        name="Shared Charter"
        details={details}
        price={shared_charter.pricing}
        onClick={this.openSharedCharterOption}
        className={classNames({invisible: this.props.trayLoading})}
      />
    )
  }

  renderByTheSeat() {
    const continuous = this.props.trayOptions.continuous;
    if (!_.isEmpty(continuous.departures)) {
      return
    }

    return (
      <DateSelectionTrayOption
        name="By The Seat"
        details="Purchase seats on existing flights"
        disabledDetails={`No scheduled flights available on ${moment(this.props.selected_date).format('MMM D')}, please try another day or charter a flight`}
        disabledCallToAction={this.renderSetFlightAlert()}
        price={this.props.trayOptions.schedule.pricing}
        perSeat={true}
        departures={this.props.trayOptions.schedule.departures}
        onClick={this.openPublishedFareOption}
        className={classNames({invisible: this.props.trayLoading})}
      />
    )
  }

  renderLoadingSpinner() {
    if (this.props.trayLoading) {
      return (
        <div className="spinner-container">
          <div className="spinner-flex">
          <span className="fa fa-spinner fa-spin"/>
          </div>
        </div>
      )
    }
  }

  renderOptions() {
    return (
      <div className="options">
        {this.renderContinuous()}
        {this.renderByTheSeat()}

        {this.renderSharedCharter()}

        <DateSelectionTrayOption
          name="Crowdsource"
          details="Launch a flight, sell unused seats for BLADE credits"
          disabledDetails="Crowdsourcing not available on this route, please Charter a flight"
          price={this.props.trayOptions.crowdsource.pricing}
          perSeat={true}
          departures={this.props.trayOptions.crowdsource.departures}
          onClick={this.openCrowdsourceOption}
          className={classNames({invisible: this.props.trayLoading})}
        />

        <DateSelectionTrayOption
          name="Charter"
          details="Your own private aircraft"
          price={this.props.trayOptions.charter.pricing}
          departures={this.props.trayOptions.charter.departures}
          onClick={this.openCharterOption}
          className={classNames({invisible: this.props.trayLoading})}
        />
      </div>
    );
  }

  renderSetFlightAlert() {
    const params = this.props.searchParams;
    const queryString = $.param({search_params: params});
    const url= '/flight_alerts/new?' + queryString;

    return (
      <a
        className="btn btn-default pull-right"
        style={{textTransform: 'capitalize'}}
        href={url}
      >
        Set Flight Alert
      </a>
    );
  }

  render() {
    if(!this.props.selected_date) {
      return <div />
    }

    return (
      <Modal
        show={true}
        className={classNames(
          'date-selection-tray-modal',
          {'in': this.state.modalOpen}
        )}
        onClick={this.clearSelectedDate}>

        <div className="date-selection-tray">
          <div>
            {this.renderHeading()}
            <div className="tray-body">
              {this.renderLoadingSpinner()}
              {this.renderOptions()}
            </div>
          </div>
        </div>

      </Modal>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    origins: state.productSearch.origin_selections,
    origin_label: state.productSearch.origin_search_label,
    origin_station_result: state.productSearch.origin_station_result,
    destination_label: state.productSearch.destination_search_label,
    destinations: state.productSearch.destination_selections,
    destination_station_result: state.productSearch.destination_station_result,
    passengers: state.productSearch.passenger_quantity,
    selected_date: state.productSearch.travel_date_selection,
    trayOptions: state.productSearch.date_selection_tray.options,
    trayLoading: state.productSearch.date_selection_tray.loading,
    searchParams: buildSearchParams(state, 'schedule')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(productSearchActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DateSelectionTray);
